export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID;

// GA_TRACKING_ID is a GTM container id, so it cannot derive the `_ga_<STREAM_ID>` cookie name.
export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
